import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team--bulk-creation"
export default class extends Controller {
  static targets = ["tbody", "template", "errorMessage"];
  connect() {
    this.index = this.tbodyTarget.querySelectorAll("tr").length;
  }

  validateSubmit(event) {
    const rows = this.tbodyTarget.querySelectorAll("tr")
    let hasValidRow = false

    rows.forEach(row => {
      const inputs = row.querySelectorAll("input[type='text']")
      const code = inputs[0]?.value.trim()
      const name = inputs[1]?.value.trim()

      if (code && name) {
        hasValidRow = true
      }
    })

    if (!hasValidRow) {
      event.preventDefault()
      this.errorMessageTarget.innerHTML = '<p class="text-body-secondary">取り込み対象がありません（コード・名称が両方ある行のみ取り込みます）</p>'
    } else {
      this.errorMessageTarget.innerHTML = ''
    }
  }

  getTemplateRow() {
    return `
      <tr>
        <td>
          <input type="text" name="teams[${this.index}][code]" class="form-control w-100" placeholder="例：A班 / GRP01">
        </td>
        <td>
          <input type="text" name="teams[${this.index}][name]" class="form-control w-100" placeholder="例：第1作業班">
        </td>
        <td>
          <button type="button" class="btn btn-sm btn-outline-soft-danger rounded-3" data-action="team--bulk-creation#removeRow">削除</button>
        </td>
      </tr>
    `.trim();
  }

  addRow(event) {
    event.preventDefault()
    const newRow = document.createElement("tr")
    newRow.innerHTML = this.getTemplateRow()
    this.tbodyTarget.appendChild(newRow)
    this.index++
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest("tr")
    if (row) {
      row.remove()
    }
  }

  clear(event) {
    event.preventDefault()
    this.tbodyTarget.querySelectorAll("input").forEach(input => input.value = "")
  }

  addSampleRows(event) {
    event.preventDefault()
    const samples = [
      { code: "A001", name: "第1作業班" },
      { code: "B002", name: "第2作業班" },
      { code: "C003", name: "第3作業班" }
    ]

    // Clear existing rows
    this.tbodyTarget.innerHTML = ""
    this.index = 0

    samples.forEach(sample => {
      const newRow = document.createElement("tr")
      newRow.innerHTML = this.getTemplateRow()
      const inputs = newRow.querySelectorAll("input")
      inputs[0].value = sample.code
      inputs[1].value = sample.name
      this.tbodyTarget.appendChild(newRow)
      this.index++
    })
  }

}

